import { TableCell } from "@/components/ui/table";
import { LabelPerson } from "@/features/person/components/LabelPerson";
import { cn } from "@/lib/cn";
import type { TableRowData } from "./types";

interface PersonCellProps {
  row: TableRowData;
  rowIndex: number;
  hoveredRowIndex: number | null;
  handleCellMouseEnter: (rowIndex: number, colIndex: number) => void;
}

export const PersonCell = ({
  row,
  rowIndex,
  hoveredRowIndex,
  handleCellMouseEnter,
}: PersonCellProps) => {
  return (
    <TableCell
      className={cn(
        "p-2 min-w-32 sticky left-0 z-10",
        hoveredRowIndex === rowIndex ? "bg-neutral-gray-light-3" : "bg-white",
        "shadow-md",
      )}
      onMouseEnter={() => handleCellMouseEnter(rowIndex, 0)}
    >
      <LabelPerson
        name={row.target.targetName}
        avatarUrl={row.target.targetAvatarUrl}
        size="Default"
        hoverScale={false}
      />
    </TableCell>
  );
};
